import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "./Logo";
import { Menu, X, LogOut } from "lucide-react";

const links = [
  { to: "/#how", label: "How it works" },
  { to: "/#evidence", label: "Beyond the résumé" },
  { to: "/pricing", label: "Pricing" },
  { to: "/mobility", label: "Global Mobility" },
];

export function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const dashPath = user
    ? user.role === "candidate" ? "/candidate"
      : (user.role === "admin" || user.role === "super_admin") ? "/admin" : "/employer"
    : "/login";

  return (
    <header className="fixed top-0 inset-x-0 z-50 ta-glass border-b border-white/10">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.to} href={l.to} data-testid={`nav-${l.label.split(" ")[0].toLowerCase()}`}
               className="text-sm text-muted hover:text-ink transition-colors duration-200">{l.label}</a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <>
              <Link to={dashPath} data-testid="nav-dashboard-btn"
                className="text-sm px-4 py-2 rounded-full border border-white/15 text-ink hover:bg-white hover:text-black transition-colors duration-200">
                Dashboard
              </Link>
              <button onClick={() => { logout(); nav("/"); }} data-testid="nav-logout-btn"
                className="text-muted hover:text-signal transition-colors duration-200"><LogOut size={18} /></button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login-btn"
                className="text-sm text-muted hover:text-ink transition-colors duration-200">Sign in</Link>
              <Link to="/register?role=startup_employer" data-testid="nav-cta-btn"
                className="text-sm px-4 py-2 rounded-full bg-azure text-white hover:bg-white hover:text-black transition-colors duration-200 font-medium">
                Find Talent
              </Link>
            </>
          )}
        </div>
        <button className="lg:hidden text-ink" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden ta-glass border-t border-white/10 px-5 py-4 space-y-3">
          {links.map((l) => (
            <a key={l.to} href={l.to} onClick={() => setOpen(false)}
               className="block text-sm text-muted hover:text-ink">{l.label}</a>
          ))}
          <div className="pt-3 border-t border-white/10 flex flex-col gap-2">
            {user ? (
              <Link to={dashPath} className="text-sm text-azure">Dashboard</Link>
            ) : (
              <>
                <Link to="/login" className="text-sm text-muted">Sign in</Link>
                <Link to="/register?role=startup_employer" className="text-sm text-azure">Find Talent</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
